
import superagent from "superagent";
import {authorize} from "../helper/authorize-token";
import {deep_assign, deep_copy} from "../../lib/js-utils";
const SET_PORFOLIO_LOADING = "SET_PORFOLIO_LOADING";
const LOAD_PORTFOLIO = "LOAD_PORTFOLIO";

const loadPortfolio = (username, index, chart_colors) => {
  return (dispatch, getState) => {
    const portfolio_store = getState().portfolio;
    if (portfolio_store[username] && portfolio_store[username][index]) {
      return;
    }
    dispatch({
      type: SET_PORFOLIO_LOADING,
      loading: true,
      username,
      index,
    });
    dispatch({
      type: LOAD_PORTFOLIO,
      payload: superagent
        .post("/api/dashboard/portfolio")
        .send({
          username,
          index,
          chart_colors,
        })
        .use(authorize(getState()))
    });
  }
}

const ZERO_STATE = {};

const adminPortfolioReducer = (state = ZERO_STATE, action) => {

  const new_state = deep_copy(state);

  switch(action.type) {
    case SET_PORFOLIO_LOADING:
      new_state.loading = action.loading;
      deep_assign(new_state, [action.username, action.index], { loading: action.loading });
      break;
    case LOAD_PORTFOLIO + "_FULFILLED":
      const response = action.payload.body.data
      new_state.loading = false;
      if (Object.keys(response.portfolio).length > 0) {
        deep_assign(new_state, [response.username, response.index],
          {
            loading: false,
            portfolio: response.portfolio,
            events: response.events,
          });
      } else {
        console.log("No portfolio for", response.username, response.index);
      }
      break;
    default:
      break;
  }

  return new_state;
}

export { adminPortfolioReducer, loadPortfolio };
